import $ from 'jquery';

function smallHeader() {
  const header = $('.header');
  const headerHeight = header.height();
  const scrollPos = window.scrollY;

  if ($(window).width() > 768) {
    if (scrollPos > headerHeight) {
      header.addClass('header--small');
    } else {
      header.removeClass('header--small');
    }
  }
}

function init() {
  smallHeader();

  $(document).scroll(function () {
    smallHeader();
  });
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};


